import React from 'react';
import './RotatingBall.css';

/**
 * @file Renders a rotating football image that is used as a loading indicator.
 */

/**
 * A rotating football image component.
 *
 * @param {object} props - The component's props.
 * @param {string} [props.size='w-8 h-8'] - The size of the image.
 * @param {string} [props.className=''] - Additional CSS classes to apply to the image.
 * @returns {JSX.Element} The rendered RotatingBall component.
 */
const RotatingBall = ({ size = 'w-8 h-8', className = '' }) => {
  return (
    <img
      src="/images/football.png"
      alt="Loading..."
      className={`rotating-ball ${size} ${className}`}
    />
  );
};

export default RotatingBall;
